module.exports = __webpack_public_path__ + "img/la_cross_section.a536806f.png";